/**
 * Extracts the participantId from the ID token sub claim.
 * Expected format: "accountless|esign|<participant-id>"
 * Returns null if the format is invalid or participantId cannot be extracted.
 */
export function extractParticipantIdFromToken(
  idTokenClaims: { sub?: string } | null | undefined,
): string | null {
  if (!idTokenClaims?.sub) {
    return null;
  }

  const subParts = idTokenClaims.sub.split('|');

  if (
    subParts.length === 3 &&
    subParts[0] === 'accountless' &&
    subParts[1] === 'esign'
  ) {
    return subParts[2].toLowerCase();
  }

  return null;
}
